import React from "react";
import { Row, Col } from 'react-bootstrap';
import LineHorizontal from '../components/LineHorizontal.js'

export default class Home extends React.Component {
  render() {
    return (
    	<Row>
    		<Col md={12}>
          <h2 className="text-center">Welcome to Crowtech</h2>
    		</Col>
        <Col md={12}>
          <LineHorizontal/>
        </Col>
        <Col md={10} mdOffset={1}>
          <p>Founded in 1993 by Adam Crow, Crowtech is an IT consultacy specialising in Advanced System Design. Adam's extensive knowledge of Science and Technology has permitted him to invent many things and processes. His software and hardware experience enables his commercialise his innovation.</p>
          <p>Crowtech is keen to continue the pursuit of innovation and introducing advanced modern techniques into industry.</p>
        </Col>
    	</Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/pages/Home.js